import './ProjectDetails.css'
import React from 'react';
import { useParams } from 'react-router';
import projects from '../../projects-data';

const ProjectDetails = () => {
    const { id } = useParams()
    const { img, title, subTitle, details, technologyUsed, screebShots } = projects[id - 1]

    return (
        <div className='project-details'>
            <h1>
                <span className="project-title">{title}</span>
                <span className="project-subtitle">
                    - <small><i>{subTitle}</i></small>
                </span>
            </h1>
            {/* <div
                style={{
                    background: `url(${img})`,
                    backgroundSize: 'cover',
                    width: '100%',
                    height: "40vw"
                }}
                className="main-img"></div> */}

            <ul className='details' >{
                details.map(item => <li>{item}</li>)
            }
                <li><b
                    style={{ color: '#ffb400' }}>Technology used:  </b> {technologyUsed}</li>
            </ul>

            <div className="all-links">
                <a href="http://" target="_blank" rel="noopener noreferrer"> Live Links </a>
                ||
                <a href="http://" target="_blank" rel="noopener noreferrer" >  Client Side Github </a>
                ||
                <a href="http://" target="_blank" rel="noopener noreferrer"> Server Side Github </a>
            </div>
            <br /><br />

            <h1>Screenshots:</h1>
            <div className="screenshots">
                {
                    screebShots.map(item => <img src={item} alt="" />)
                }
            </div>

        </div>
    );
};

export default ProjectDetails;